export function extractDateObject(dateTime: string) {
    return new Date(dateTime);
}
